
import { motion } from "framer-motion";

const FeaturedOnSection = () => {
  const newsLogos = [
    {
      id: 1,
      name: "Crypto Daily",
      src: "/lovable-uploads/bb699bcc-df9f-4fe6-b69e-6fa64765f046.png",
      alt: "Crypto Daily logo",
      ext_url: "https://cryptodaily.co.uk/2025/04/crypto-made-simple-how-metrade-marketplace-lets-you-invest-like-a-pro-without-the-complexity"

    },
    {
      id: 2,
      name: "CoinPedia",
      src: "/lovable-uploads/bf9cdc94-db08-4840-bae6-869c2f0c41bb.png",
      alt: "CoinPedia logo",
      ext_url: "https://coinpedia.org/information/metrade-marketplace-lets-you-participate-even-while-you-sleep/"

    },
    {
      id: 3,
      name: "Blockchain Magazine",
      src: "/lovable-uploads/647315c5-de8b-4431-af81-e5c19b16178b.png",
      alt: "Blockchain Magazine logo"
    },
    {
      id: 4,
      name: "CoinMarketCap",
      src: "/lovable-uploads/5f8b8978-d677-4d49-8a6d-25b2edb47af4.png",
      alt: "CoinMarketCap logo",
      ext_url: "https://coinmarketcap.com/community/articles/67ecef244b2ccd18849a7f0f/"
    },
    {
      id: 5,
      name: "Crypto Wisser",
      src: "/lovable-uploads/871df7fe-864a-43af-ab91-e4c5ed894c42.png",
      alt: "Crypto Wisser logo",
      ext_url: "https://www.cryptowisser.com/discover-the-power-of-community/"
    },
    {
      id: 6,
      name: "TechBullion",
      src: "/lovable-uploads/4635973a-ce34-40f2-8cb6-56b65f9c8d0c.png",
      alt: "TechBullion logo",
      ext_url: "https://techbullion.com/the-future-of-crypto-investing-how-metrade-marketplace-puts-you-in-control-without-the-stress/"
    },
    {
      id: 7,
      name: "Binance",
      src: "/lovable-uploads/Binance_logo.png",
      alt: "Binance",
      ext_url: "https://www.binance.com/en-NG/square/post/22368249072697"
    }
  ];

  return (
    <section className="py-16 bg-corporate-white border-b border-corporate-neutral-25">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-corporate-primary-75 mb-4">
            Featured on
          </h2>
          <p className="text-corporate-neutral-75 text-lg max-w-2xl mx-auto">
            Trusted by top crypto news platforms
          </p>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex flex-wrap justify-center items-center gap-x-8 gap-y-2 md:gap-x-12 md:gap-y-2"
        >
          {newsLogos.map((logo) => (
            <div 
              key={logo.id} 
              className="flex items-center justify-center w-48 h-40 grayscale hover:grayscale-0 transition-all duration-300"
            >
              <a href={logo.ext_url} target="_blank" rel="noopener noreferrer">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-w-full max-h-full object-contain"
                />
              </a>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedOnSection;
